<template>
  <div class="nav">
    <!-- <span class="fl lh60 col-fff mr20">{{name}}</span> -->
    <!-- <Msg></Msg> -->
    <Screenfull></Screenfull>
    <Dropdown></Dropdown>
  </div>
</template>

<script>
import Screenfull from "./screenfull";
import Dropdown from "./dropdown";
import Msg from "./msg";
import { clear, getInfo } from "../utils/token";
export default {
  name: "navbar",
  computed: {},
  components: {
    Screenfull: Screenfull,
    Dropdown: Dropdown,
    Msg: Msg,
  },
  data() {
    return {
      name: "",
    };
  },
  mounted() {
    // let info = getInfo();
    // this.name = info.info.name;
  },
};
</script>

<style lang="scss" scoped>
.nav {
  float: right;
  height: 60px;
  //   line-height: 60px;
}
</style>